import { PageWrapper } from '@otomoro/components/layout/PageWrapper'
import { Headline } from '@otomoro/components/shared/Headline'
import { NewsCardsList } from '@otomoro/components/news'
import { NewsPageProps } from './NewsPage.types'
import { Categories } from '@otomoro/components/shared/Categories/Categories'

export default function NewsPage({ data, nextArticles, searchParams }: NewsPageProps) {
	if (!data) {
		return (
			<div className="text-center">
				Please start editing your Technology document to see the preview!
			</div>
		)
	}
	const { articles, newsPage, newsTypes } = data
	if (!newsPage) return null

	return (
		<PageWrapper noPb theme="light">
			<Headline
				border
				headlineText={newsPage.headline}
				subheadline={newsPage.subHeadline}
			></Headline>
			<Categories searchParams={searchParams} newsTypes={newsTypes} />
			<NewsCardsList
				articles={articles}
				newsPage={newsPage}
				featuredArticle={newsPage.featuredArticle}
				nextArticles={nextArticles}
				activeType={searchParams.filterBy || null}
			/>
		</PageWrapper>
	)
}
